<template lang="pug">
	v-container(grid-list-md)
		v-layout(row wrap)
			v-flex(xs12)
				v-card
					v-card-title.red.darken-3.white--text.subheading(primary-title)
						span.title {{$vuetify.t('$vuetify.pages.404.title')}}
					v-card-text {{$vuetify.t('$vuetify.pages.404.text')}}
					v-card-actions
						v-btn.red--text(outline to="/") {{$vuetify.t('$vuetify.pages.404.return')}}
</template>

<script>
export default {
    name: 'Page404'
}
</script>
